import LabServiceCollection from "@/collections/LabServiceCollection";
import SubmissionStatusModel from "@/models/lab/SubmissionStatusModel";

export default class SubmissionStatusCollection extends LabServiceCollection {

  model() {
    return SubmissionStatusModel;
  }

}
